import { detailedSearchActions } from '../../services';
import { isEqual } from 'lodash';

export const detailedSearchReducer = ( state = { page: 0, request: '', results: [], totalItems: 0, totalPages: 0,comb:[{page:0, pageSize:10}] }, action ) => {
  let oldState = { ...state };
  switch ( action.type ) {
    case detailedSearchActions.LOAD:
      if ( !action.data ) {
        return state;
      }
      if ( oldState.results.length>0 && isEqual( state.request, action.data.request ) && !oldState.comb.find((c)=>{return c.page===action.data.page && c.pageSize===action.data.pageSize}) ) {
        
        oldState.comb.push({page:action.data.page, pageSize:action.data.pageSize})
        let newData = []
        if(action.data.results && action.data.results.length>0){
          for(let i=0; i<action.data.results.length; i++){
            let index = action.data.page*action.data.pageSize+i;
            let product = oldState?.results.find((p)=>p.tableIndex===index);
            if(!product){
              newData.push({...action.data.results[i], "tableIndex":index});
            }
          }
          action.data.results = newData;
        }
        action.data.results.sort((a,b)=>a.tableIndex-b.tableIndex);

        action.data.results = oldState.results.concat( action.data.results );
      }
      else if(action.data.page===0 && action.data.pageSize===10){
        action.data.results = action.data.results && action.data.results.length>0?action.data.results.map((prod, key)=>{
          let index = action.data.page*action.data.pageSize+key;
          return {...prod, "tableIndex":index};
        }):action.data.results;
      }

      return {...action.data, "comb":oldState.comb};

    case detailedSearchActions.GET:
    default:
      return state;
  }
};